import { AspectRatio, Box, Image } from '@amzn/ring-ui-react-components';
import { useMemo } from 'react';
import { ASPECT_RATIO } from './constants';

export interface ThumbnailProps {
  orientation: 'portrait' | 'landscape';
  src?: string;
  caption?: string;
}

export const Thumbnail = (props: ThumbnailProps) => {
  const ratio = useMemo(
    () =>
      props.orientation === 'portrait'
        ? ASPECT_RATIO.PORTRAIT
        : ASPECT_RATIO.LANDSCAPE,
    [props.orientation],
  );

  return (
    <Box
      width="100%"
      height="100%"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <AspectRatio width="100%" maxHeight="100%" ratio={ratio}>
        <Image
          src={props.src}
          style={{ objectFit: 'contain' }}
          data-testid="thumbnail-image"
        />
      </AspectRatio>
      {props.caption && (
        <Box
          textStyle="body-small-medium"
          color="white"
          position="absolute"
          bottom={0}
          left={0}
          right={0}
          p={2}
          data-testid="caption"
          style={{
            background:
              'linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 99.03%)',
          }}
        >
          {props.caption}
        </Box>
      )}
    </Box>
  );
};
